import { Stack } from '@mui/material';
import Text from 'components/Text';

const SnowloadImage = () => (
  <Stack spacing={1} sx={{ width: '100%' }} alignItems="start">
    <img src="/ASCE Tool Category 2.jpg" alt="ASCE Tool Category 2" style={{ height: '600px' }} />
    <Text>Example of Risk Category II</Text>
  </Stack>
);

export default SnowloadImage;
